<!--  -->
<template>
	<div class="container">
		<div class="search-container flex flex-between" ref="tableHeight">
			<div class="flex">
				<el-input v-model.trim="licensePlate" class="" size="small" placeholder="车牌号" maxlength="16" clearable @keyup.enter.native="handleSerch">
				</el-input>
				<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSerch()" alt="">
			</div>
			<div v-if="isEdit&&roleType">
				<img class="icon-img ml7" src="@/assets/images/delete.png" @click="deleteRow" title="删除" alt="">
				<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit" title="新增" alt="">
			</div>
		</div>
		<div class="table-container">
			<el-table
				ref="multipleTable"
				v-if="tableData.length>0"
				v-el-table-infinite-scroll="tableLoad"
				:infinite-scroll-distance="50"
				:infinite-scroll-immediate="false"
				:data="tableData"
				:height="height"
				:cell-style="cellStyle"
				:row-class-name="tabRowClassName"
				:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
				:row-key="(row) => {return row.carId}"
				@selection-change="handleSelectionChange"
				border style="width: 100%"
				@cell-click="editRow">
				<el-table-column type="selection" width="50" :reserve-selection="true" align="center">
				</el-table-column>
				<el-table-column prop="licensePlate" width="200" label="车牌号" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="carName" width="200" label="车辆名称" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="etcCode" label="ETC编码" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="groupName" label="组织部门" :show-overflow-tooltip="true" sortable>
				</el-table-column>
				<el-table-column prop="remark" label="备注" :show-overflow-tooltip="true" >
				</el-table-column>
			</el-table>
			<el-empty v-else :style="{height:height+'px'}"  description="暂无数据"></el-empty>
			<div class="flex flex-between search-container">
					<div class="totalPage">
						当前第<span class="page-active">{{currentNo}}</span>页，共<span class="page-active">{{totalCount}}</span>条数据，共<span class="page-active">{{totalPage}}</span>页
					</div>
				<img class="icon-img" style="vertical-align: middle;" src="@/assets/images/down.png" @click="download" title="导出" alt="">
			</div>
		</div>
		<!-- 编辑 -->
	   <carEdit ref="carEdit" @handleSerch="handleSerch"></carEdit>

	</div>
</template>

<script>
	import { debounce } from '@/utils/debounce'
	import carEdit from './components/car-edit.vue'
	import { hasPermission } from '@/utils/permission'
	export default {
		name:'vehicleInfo',
		components: {
			carEdit
		},
		data() {
			return {
				height: 500,
				pageNo: 1,
				pageSize: 40,
				totalPage: 0,
				licensePlate: '',
				tableData: [],
				titles: [],
				multipleSelection: [],
				infiniteFlag: false,
				isEdit:false,
				roleType:window.sessionStorage.getItem("roleType")==2?false:true,
				totalPage:"",
				totalCount:"",
				currentNo:"",

			}
		},
		mounted() {
			this.getList();
			let height = this.$refs.tableHeight.offsetHeight;
			this.height = window.innerHeight - 126 - height;
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
				// console.log(this.isEdit)
			}
		},
		methods: {
			tabRowClassName({
				row,
				rowIndex
			}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			cellStyle({row, column, rowIndex, columnIndex}) {
				if(columnIndex == 1) {
					return 'cursor: pointer;'
				}
			},
			// 获取列表
			getList(type) {
				if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
					"carInfoList",
					true, {
						pageNo: that.pageNo,
						pageSize: that.pageSize,
						licensePlate: that.licensePlate
					}
				)
				.then((res) => {
					if (res) {
						that.infiniteFlag = res.data.totalPage <= that.pageNo;
						if(type == 'scroll') {
							that.tableData = that.tableData.concat(res.data.list);
							that.totalPage=res.data.totalPage
								that.totalCount=res.data.totalCount
								that.currentNo = res.data.pageNo
						}else {
							if (res.data && res.data.list.length > 0) {
									that.tableData = res.data.list;
									that.totalPage=res.data.totalPage
									that.totalCount=res.data.totalCount
									that.currentNo = res.data.pageNo

								} else {
									that.titles = []
									that.tableData = []
									that.totalPage=0
									that.totalCount=0
									that.currentNo = 0
								}
						}
					}
				})
			},
			// 表格滚动加载
			tableLoad:debounce(function() {
				this.pageNo++;
				this.getList('scroll');
			},100,true),
			// 查询
			handleSerch() {
				if(this.tableData.length > 0){
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}
				this.infiniteFlag = false;
				this.pageNo = 1;
				this.$nextTick(() => {
					this.getList();
				})
			},
			// 新增
			handleEdit() {
				this.$refs.carEdit.init();
			},
			// 查看/编辑
			editRow(row, column, cell, event){
				if(column.label == '车牌号') {
					this.$refs.carEdit.init(row);
				}else {
					this.$refs.multipleTable.toggleRowSelection(row);
				}
			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 删除
			deleteRow() {
				let that = this;
				if(that.multipleSelection.length == 0){
					that.$message.error('请先选择需要删除的车辆');
					return
				}
				let carIds = [];
				that.multipleSelection.forEach(item => {
					carIds.push(item.carId);
				})
				that.$confirm('是否确认删除？',  {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					that.$request.post(
						"deleteCarInfo",
						false, {
							carIds: carIds,
						}
					)
					.then((res) => {
						if (res) {
							that.$message.success("删除成功");
							that.handleSerch();
						}
					})
				}).catch(() => {});
			},
			// 导出
			download() {
				let that = this;
				let carIds = [];
				that.multipleSelection.forEach(item => {
					carIds.push(item.carId);
				})
				that.$request.post(
						"carInfoExport",
						true, {
							pageNo: 1,
							pageSize: 50000,
							licensePlate: that.licensePlate,
							carIds:carIds
						}
					)
					.then((res) => {
						if (res) {
							let downloadURL = res.data
							const linkNode = document.createElement('a');
							linkNode.style.display = 'none';
							linkNode.href = downloadURL;
							document.body.appendChild(linkNode);
							linkNode.click(); //模拟在按钮上的一次鼠标单击
							URL.revokeObjectURL(linkNode.href); // 释放URL 对象
							document.body.removeChild(linkNode);
						}
					})
			},
		},
	}

</script>

<style lang='scss' scoped>
	.container {
		background: #fff;
		box-sizing: border-box;
		margin: 12px 26px 15px 10px;
		// padding-bottom: 20px;

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 0px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			/deep/ th .el-table__cell{
				padding: 0 !important;
			}
		}
	}

	.red {
		width: 50px;
		height: 20px;
		background: #D9001B;
	}

	.blue {
		width: 50px;
		height: 20px;
		background: #02A7F0;
	}

	.search-container {
		padding: 8px;
	}

</style>
